import { render } from "./TopUpForm.vue?vue&type=template&id=27fa002c"
import script from "./TopUpForm.vue?vue&type=script&lang=js"
export * from "./TopUpForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__